import styled from 'styled-components'
import { QuillEditor } from 'components/common/QuillEditor'

type TWrapperProps = {
  maxHeight: string
  minHeight: string
  borderRadius?: string
}

export const RichTextEditorWrapper = styled.div<TWrapperProps>`
  display: block;
  width: 100%;
  ${({ borderRadius }) =>
    borderRadius &&
    `
      border-radius: ${borderRadius};
      overflow: hidden; /* ensure children follow the radius */
    `}

  & .ql-editor {
    min-height: ${props => props.minHeight};
    max-height: ${props => props.maxHeight};
  }
`

interface TStyledQuillEditorProps {
  borderRadius?: string
  borderColor?: string
}

export const StyledQuillEditor = styled(QuillEditor)<TStyledQuillEditorProps>`
  /*
    Quill renders two sibling elements inside the root div:
    1. .ql-toolbar      – holds all formatting buttons
    2. .ql-container    – holds the editable area

    Each of these elements has its own border, so we have to set the
    radius on both to get the full rounded-corner effect.
  */

  /* top */
  .ql-toolbar.ql-snow {
    ${({ borderColor }) => borderColor && `border-color: ${borderColor};`}
    ${({ borderRadius }) =>
      borderRadius &&
      `
        border-top-left-radius: ${borderRadius};
        border-top-right-radius: ${borderRadius};
      `}
  }

  /* bottom */
  .ql-container.ql-snow {
    ${({ borderColor }) => borderColor && `border-color: ${borderColor};`}
    ${({ borderRadius }) =>
      borderRadius &&
      `
        border-bottom-left-radius: ${borderRadius};
        border-bottom-right-radius: ${borderRadius};
      `}
  }
`
